import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Box, Grid, Button } from '@mui/material';
import {
  TextInput,
  FileUploadContract,
  ComboBox,
  ArrayInput,
  Selection,
  SimpleComboBox,
} from 'components';
import Utils from 'commons/utils';
import ApiServices from 'services';
import { SEX, RESPONSE_STATUSES } from 'commons/constants';

const VendorForm = ({
  clientCareHistoryItem,
  clientInformationDetail,
  onCloseModal,
  reloadData,
}) => {
  const serviceList = clientCareHistoryItem?.arrService?.filter((ser) => !ser.parentServiceId);
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [arrNumberPhone, setArrNumberPhone] = useState([]);
  const [arrAddress, setArrAddress] = useState([]);
  const [email, setEmail] = useState('');
  const [arrServiceId, setArrServiceId] = useState([]);

  const handleChangeCode = useCallback(
    (e) => {
      setCode(e.target.value);
    },
    [code],
  );
  const handleChangeName = useCallback(
    (e) => {
      setName(e.target.value);
    },
    [name],
  );
  const handleChangeArrNumberPhone = useCallback(
    (e) => {
      setArrNumberPhone(e.target.value);
    },
    [arrNumberPhone],
  );
  const handleChangeArrAddress = useCallback(
    (e) => {
      setArrAddress(e.target.value);
    },
    [arrAddress],
  );
  const handleChangeArrService = useCallback(
    (e) => {
      setArrServiceId(e.target.value);
    },
    [arrServiceId],
  );

  const handleChangeEmail = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [email],
  );

  const handleSubmit = async () => {
    const dataSend = { code, name, arrServiceId, arrNumberPhone, email, arrAddress };
    setLoading(true);
    return ApiServices.createVendorService(dataSend)
      .then((res) => {
        if (res.status === RESPONSE_STATUSES.OK) {
          window.UIMessage?.success('Thêm mới thành công');
          onCloseModal();
          reloadData();
        }
      })
      .catch((err) => {
        window.UIMessage?.error('Thêm mới thất bại !!!');
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput
            required
            error={!code}
            helperText={!code && 'Vui lòng nhập Mã'}
            label="Mã"
            name="code"
            onChange={handleChangeCode}
            value={code}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput
            required
            error={!name}
            helperText={!name && 'Vui lòng nhập Tên đối tác'}
            label="Tên đối tác"
            name="name"
            onChange={handleChangeName}
            value={name}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput
            required
            error={!email}
            helperText={!email && 'Vui lòng nhập Email'}
            label="Email"
            name="email"
            onChange={handleChangeEmail}
            value={email}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <Selection
            sx={{ marginTop: '10px' }}
            required
            error={Boolean(!arrServiceId)}
            helperText={!arrServiceId && 'Vui lòng nhập dịch vụ'}
            label="Danh sách dịch vụ"
            name="arrServiceId"
            multiple={true}
            onChange={handleChangeArrService}
            value={arrServiceId}
            fieldValue="id"
            fieldView="name"
            dataArrObject={serviceList || []}
            displayNone={false}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <ArrayInput
            value={arrNumberPhone}
            fullWidth
            onChange={handleChangeArrNumberPhone}
            label="Số điện thoại"
            name="arrNumberPhone"
          />
        </Grid>

        <Grid item xs={6} sm={6} md={6}>
          <ArrayInput
            value={arrAddress}
            fullWidth
            onChange={handleChangeArrAddress}
            label="Địa chỉ"
            name="arrAddress"
          />
        </Grid>
      </Grid>
      <Box sx={{ py: 2, display: 'flex' }}>
        <Button
          color="primary"
          style={{
            marginLeft: 'auto',
            padding: '6px 30px',
          }}
          size="small"
          variant="contained"
          onClick={handleSubmit}
        >
          Thêm mới
        </Button>
      </Box>
    </Box>
  );
};

export { VendorForm };
